(function () {
  if (window.brCollectionSeoBottomLoaded) return;
  window.brCollectionSeoBottomLoaded = true;

  var mq = window.matchMedia("(max-width: 999px)");

  function setup() {
    if (!mq.matches) return;
    document
      .querySelectorAll(".collection_seo_bottom")
      .forEach(function (root) {
        var toggle = root.querySelector(".collection_seo_bottom__toggle");
        var paragraphs = root.querySelectorAll(
          ".collection_seo_bottom__paragraph",
        );
        if (!toggle || !paragraphs.length) return;
        root.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = toggle.dataset.labelMore;
        var firstText = paragraphs[0].querySelector("p");
        var overflows =
          firstText && firstText.scrollHeight > firstText.clientHeight + 1;
        var needsToggle = paragraphs.length > 1 || overflows;
        toggle.hidden = !needsToggle;
        if (!needsToggle) root.classList.add("is-open");
      });
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest(".collection_seo_bottom__toggle");
    if (!toggle) return;
    var root = toggle.closest(".collection_seo_bottom");
    var isOpen = root.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    toggle.textContent = isOpen
      ? toggle.dataset.labelLess
      : toggle.dataset.labelMore;
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
  document.addEventListener("shopify:section:load", setup);
  mq.addEventListener("change", setup);
})();
